var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showCompleteAppBanner
        ? _c("fixed-banner", { attrs: { type: "success" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.messages.applicationIsCompleted")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showMissingFilogixDetailsBanner
        ? _c(
            "fixed-banner",
            { attrs: { type: "notice" } },
            [
              _c("i18n", {
                staticClass: "m-0",
                attrs: { path: _vm.errorMessagePath },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "link",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-white bold clickable",
                              attrs: {
                                to: {
                                  path: "/personal-settings/account/filogix-details",
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.accountTab.lenderSubmissionDetails"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _c("icon", { attrs: { name: "external-link" } }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  508416378
                ),
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "text-white btn-sm btn-transparent bs-0 p-0 underline clickable",
                  on: { click: _vm.dismissMissingFilogixDetailsBanner },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.words.dismiss")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }